<script>
    export let title = null;
    export let message = null;
    export let icon = 'check';

    let lines = message.split("|");
</script>
<div class="page-icon info mb-5">
    <i class="fa fa-{ icon }"></i>
</div>
<div class="text-center mb-5">
    {#if title}
        <p><strong>{ title }</strong></p>
    {/if}
    {#if message}
        {#each lines as line}
            <p>{@html line }</p>
        {/each}
    {/if}
</div>